export const BACK_BUTTON_LABEL = 'Back';
export const CONTINUE_BUTTON_LABEL = 'Continue';
export const COMPLETE_BUTTON_LABEL = 'Complete';